import React, { useCallback, useEffect, useRef } from 'react';
import { MagnifierIcon } from '../../../assets/images/components/NudosComponents';
import { IElement } from '../../../types/global';
import Loading from '../Loading';
import NudosGenericSelect from '../NudosGenericSelect';
import './NudosGenericSearchBar.scss';

const NudosGenericSearchBar = ({
  searchString,
  setSearchString,
  customClassName,
  customPlaceholder,
  setIsSelectOpen,
  searchedOptions,
  handleChangeSelectedOption,
  defaultValue,
  isSelectOpen,
  noResultsMessage,
  noResultsUpdater,
  errorText,
  isDisabled,
  activeStylesIfCustomPlaceholder,
  absolutePositionElement,
  isLoading
}: InudosGenericSearchBar) => {
  const searchBarRef = useRef<HTMLDivElement>(null);

  const handleChange = (event: React.SyntheticEvent) => {
    const { value } = event.target as HTMLInputElement;
    setSearchString(value);
    if (!setIsSelectOpen) return;
    if (value.length === 0) {
      setIsSelectOpen(false);
      noResultsUpdater && noResultsUpdater('');
    }
    if (value.length > 0) setIsSelectOpen(true);
  };

  const onHandleClickAway = useCallback(
    async (e: IElement) => {
      if (searchBarRef.current && !searchBarRef.current.contains(e.target)) {
        setIsSelectOpen(false);
      }
    },
    [searchBarRef]
  );

  const activeStyles =
    searchString.length > 0 || (activeStylesIfCustomPlaceholder && customPlaceholder && customPlaceholder?.length > 0)
      ? 'active'
      : '';

  const getSelectOptions = () => {
    if (isLoading)
      return [
        <div className="loaderContainer" key="loading-option">
          <Loading />
        </div>
      ];
    if (searchedOptions) return searchedOptions;
    if (noResultsMessage) return [noResultsMessage];
    return [];
  };

  useEffect(() => {
    window.addEventListener('mousedown', onHandleClickAway);
    return () => {
      window.removeEventListener('mousedown', onHandleClickAway);
    };
  }, [onHandleClickAway]);

  return (
    <>
      <div
        className={`nudosGenericSearchBar ${customClassName ? customClassName : ''} ${activeStyles} ${
          errorText && errorText.length > 0 ? 'error' : ''
        } ${isDisabled ? 'disabled' : ''}`}
        ref={searchBarRef}
      >
        <div className="searchIconContainer">
          <MagnifierIcon className="magnifierIcon" />
        </div>
        <input
          value={searchString}
          className="searchInput"
          placeholder={customPlaceholder || 'Buscar'}
          onChange={event => handleChange(event)}
          disabled={isDisabled}
        />
        {(searchedOptions || noResultsMessage) && handleChangeSelectedOption && isSelectOpen && (
          <NudosGenericSelect
            selectOptions={getSelectOptions()}
            changeSelectedOption={handleChangeSelectedOption}
            defaultValue={defaultValue || undefined}
            absolutePositionElement={absolutePositionElement}
          />
        )}
      </div>
    </>
  );
};

export default NudosGenericSearchBar;

export interface InudosGenericSearchBar {
  searchString: string;
  setSearchString: React.Dispatch<React.SetStateAction<string>>;
  customClassName?: string;
  customPlaceholder?: string;
  setIsSelectOpen: React.Dispatch<React.SetStateAction<boolean>>;
  searchedOptions?: JSX.Element[];
  handleChangeSelectedOption?: React.Dispatch<any>;
  defaultValue?: any;
  isSelectOpen?: boolean;
  noResultsMessage?: JSX.Element;
  noResultsUpdater?: React.Dispatch<React.SetStateAction<string>>;
  errorText?: string;
  isDisabled?: boolean;
  activeStylesIfCustomPlaceholder?: boolean;
  absolutePositionElement?: JSX.Element;
  isLoading?: boolean;
}
